<script>
import Vue from "vue";

import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import "v-tooltip/dist/v-tooltip.css";

import forminput from "@/router/views/FormComponet/forminput.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrRisk from "@/models/StrRisk";
import moment from "moment";
export default {
  mixins: [Api, Sabit, StrRisk],
  props: ["Id", "AddEdit", "Risk","sira_num"],
  data() {
    return {
      FormData: {},
      Birimids:[],
      secilen_veriler:[],
      Data:null,
      Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },
    };
  },
  components: {
    Loader,
    forminput,
    formtextarea,
    formcombobox,
    BirimSecimi

  },
  watch: {
    Id() {
      this.FormData = this.Id;
      if (this.AddEdit == "Add") {
        this.FormData.SiraNo=this.sira_num;
      }

    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) { 

         //   this.FormData.KayitTarihi = moment(new Date()).format("YYYY-MM-DD");
            this.FormData.Created = moment(new Date()).format("YYYY-MM-DD");
            if (this.AddEdit == "Add") {

              if (this.secilen_veriler!=null && this.secilen_veriler!=[] && this.secilen_veriler!=""){

                for (var i=0; i<this.secilen_veriler.length; i++){
                    if (this.secilen_veriler[i] == 1) {
                        this.secilen_veriler.splice(i,1);
                    }
                }

                this.Post("StrRisk", this.FormData,false).then((res) => {
                  if(res){
                    this.Data=null;
                    this.Data={"Riskid": res.Data,"Birimids":this.secilen_veriler};
                      this.Post("StrRiskBirim", this.Data).then((res)=>{
                          if (res) {
                            this.$emit("TableUpdate");
                            this.$bvModal.hide("StrRisk");
                          }
                      });
                    
                  }
                });
              } else {

              this.Message.html="";
              this.Message.position = "center";
              this.Message.icon = "warning";
              this.Message.title = "Birim Seçimi Yapılmamış!";
              this.Message.showConfirmButton = false;
              this.Message.timer = 10000;

              Vue.swal(this.Message);
                
              }

            } else {
              this.Update("StrRisk", this.FormData).then((res) => {
                if (res) {
                  this.$emit("Update", this.FormData);
                  this.$emit("TableUpdate");
                  this.$bvModal.hide("StrRisk");
                }
              });
            }


      }
    },
    Get() {},
    amac_yukle(Donemid){
      let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }

      let filter="&DonemId="+Donemid;
    
      this.ActionsFilterGet({"Service":"StrStratejikAmac","Page":Page, Filter:filter}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Amacid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama})
        }    
    }); 

    },
    Secilmis_Idler(veriler) {
     
     this.secilen_veriler=veriler;

    this.Birimids = [];
     if (this.secilen_veriler[0] == 1) {
       this.secilen_veriler.splice(0, 1);
     }
   this.Birimids = this.secilen_veriler;
   }, 
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrRisk"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrRisk.AddEdit.FormTitleEdit')
          : $t('StrRisk.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <div class="row">
            <div class="col-md-6"> 
              <forminput
                :FormDataType="FormDataType.SiraNo"
                :Value="FormData.SiraNo"
                :v="$v.FormData.SiraNo"
                @input="FormData.SiraNo = $event"
              />  
            </div>

            <div class="col-md-6">
              <formcombobox
          :FormDataType="FormDataType.Risktipi"
          :Value="FormData.Risktipi"
          :v="$v.FormData.Risktipi"
          @input="FormData.Risktipi = $event"
        />

            </div>
        </div>
    
        <formcombobox
          :FormDataType="FormDataType.Donemid"
          :Value="FormData.Donemid"
          :v="$v.FormData.Donemid"
          @input="FormData.Donemid = $event, amac_yukle($event)"
        />
        <formcombobox
          :FormDataType="FormDataType.Amacid"
          :Value="FormData.Amacid"
          :v="$v.FormData.Amacid"
          @input="FormData.Amacid = $event"
        />

        <formtextarea
          :FormDataType="FormDataType.Hedef"
          :Value="FormData.Hedef"
          :v="$v.FormData.Hedef"
          @input="FormData.Hedef = $event"
        />

        <div class="row">
            <div class="col-md-6">
        <formcombobox
          :FormDataType="FormDataType.Riskpuanid"
          :Value="FormData.Riskpuanid"
          :v="$v.FormData.Riskpuanid"
          @input="FormData.Riskpuanid = $event"
        />
        </div>
     

            <div class="col-md-6">
      
        <formcombobox
          :FormDataType="FormDataType.Kaynakid"
          :Value="FormData.Kaynakid"
          :v="$v.FormData.Kaynakid"
          @input="FormData.Kaynakid = $event"
        />
        </div>
        </div>

        <div class="row">
            <div class="col-md-4">
          <formcombobox
          :FormDataType="FormDataType.Turid"
          :Value="FormData.Turid"
          :v="$v.FormData.Turid"
          @input="FormData.Turid = $event"
        />

        </div>
      
     
            <div class="col-md-4">
        <forminput
          :FormDataType="FormDataType.Riskno"
          :Value="FormData.Riskno"
          :v="$v.FormData.Riskno"
          @input="FormData.Riskno = $event"
        />

        </div>
    

     
            <div class="col-md-4">

        <forminput
          :FormDataType="FormDataType.Risknokodlu"
          :Value="FormData.Risknokodlu"
          :v="$v.FormData.Risknokodlu"
          @input="FormData.Risknokodlu = $event"
        />
        </div>
        </div>
        <formtextarea
          :FormDataType="FormDataType.Risk"
          :Value="FormData.Risk"
          :v="$v.FormData.Risk"
          @input="FormData.Risk = $event"
        />
        <formtextarea
          :FormDataType="FormDataType.Sebepler"
          :Value="FormData.Sebepler"
          :v="$v.FormData.Sebepler"
          @input="FormData.Sebepler = $event"
        />
       
        <formtextarea
          :FormDataType="FormDataType.Aciklama"
          :Value="FormData.Aciklama"
          :v="$v.FormData.Aciklama"
          @input="FormData.Aciklama = $event"
        />

        <b-form-group
        v-if="AddEdit == 'Add'"
      class="mb-2"
      id="donemler"
      :label="'Birim Seçimi'"
      label-for="text"
    >
              <BirimSecimi
                :title_position="'mb-3'"
                :selected="Birimids"
                :labels_lg="'3'"  
                :YetkiKontrol="1"
                :multiple="true"
                :BirimTipId="null"
                @Secilmis_Idler="Secilmis_Idler($event)"
              />
          </b-form-group>

        <button class="btn btn-primary" type="submit">
          {{ $t("StrRisk.AddEdit.Button") }}
        </button>

 
      </Form>
    </b-modal>
  </Loader>
</template>
